import { type JSX } from 'react';
import useTracking from '@/shared/hooks/useTracking';
import StateChainAccountCard from './StateChainAccountCard';
import { LiquidityProvisionEvents, type LiquidityProvisionTrackEvents } from '../../../types/track';

export const SignIn = ({ onCompleted }: { onCompleted?: () => void }): JSX.Element => {
  const track = useTracking<LiquidityProvisionTrackEvents>();

  return (
    <div className="z-10">
      <StateChainAccountCard
        onCompleted={(selectedAccount) => {
          track(LiquidityProvisionEvents.SignInSuccess, {
            props: {
              path: window.location.pathname,
              walletProvider: selectedAccount.meta.source,
              scAccount: selectedAccount.idSs58,
              scAccountName: selectedAccount.meta.name ?? '-',
            },
          });
          onCompleted?.();
        }}
      />
    </div>
  );
};
